import apiRequest from './apiRequest';

export default async function putSessionName(
  jobID: string,
  sessionName: string,
) {
  return await apiRequest(
    'mogen-orchestration',
    `/sessions/${jobID}/sessionName`,
    {
      method: 'PUT',
      body: JSON.stringify({ sessionName }),
    },
  );
}
